import React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Tooltip, { TooltipProps } from '@mui/joy/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TOOLTIP_Z_INDEX = 10001;

export function OverlayTooltip(props: TooltipProps) {
    const { slotProps, ...rest } = props;
    const rootSlot = slotProps?.root;
    const rootObject = rootSlot && typeof rootSlot === 'object' ? rootSlot : undefined;

    return (
        <Tooltip
            {...rest}
            slotProps={{
                ...slotProps,
                root: {
                    ...rootObject,
                    sx: {
                        zIndex: TOOLTIP_Z_INDEX,
                        ...(rootObject && 'sx' in rootObject ? rootObject.sx : undefined),
                    },
                },
            } as TooltipProps['slotProps']}
        />
    );
}

export function formatPercent(value: number | null | undefined): string {
    const numeric = Number(value ?? 0);
    return `${(Number.isFinite(numeric) ? numeric : 0).toFixed(1)}%`;
}

export function formatNumber(value: number | bigint | null | undefined): string {
    const numeric = typeof value === 'bigint' ? Number(value) : Number(value ?? 0);
    return (Number.isFinite(numeric) ? numeric : 0).toLocaleString('ru-RU');
}

export function HintLabel(props: { label: string; hint: string; level?: 'body-xs' | 'body-sm' }) {
    const { label, hint, level = 'body-xs' } = props;
    return (
        <OverlayTooltip title={hint} variant="outlined" placement="top">
            <Box
                component="span"
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                    cursor: 'help',
                    borderBottom: '1px dotted',
                    borderColor: 'neutral.outlinedBorder',
                }}
            >
                <Typography component="span" level={level} color="neutral">{label}</Typography>
                <InfoOutlinedIcon sx={{ fontSize: level === 'body-sm' ? 16 : 14, opacity: 0.55 }} />
            </Box>
        </OverlayTooltip>
    );
}

export function HintHeader(props: { label: string; hint: string }) {
    return (
        <th>
            <HintLabel label={props.label} hint={props.hint} level="body-sm" />
        </th>
    );
}
